module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.86d943cd.woff2";